module.exports = __webpack_public_path__ + "img/logo_square_policy_street.3cfa16b0.png";